/* tslint:disable */
/* eslint-disable */
/**
 * Změňte.to Admin API
 * Změňte.to Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BadRequestResponseDTO,
    BadRequestResponseDTOFromJSON,
    BadRequestResponseDTOToJSON,
    ConflictResponseDTO,
    ConflictResponseDTOFromJSON,
    ConflictResponseDTOToJSON,
    CreatePrefilledEmailRequestDTO,
    CreatePrefilledEmailRequestDTOFromJSON,
    CreatePrefilledEmailRequestDTOToJSON,
    CreatePrefilledEmailResponseDTO,
    CreatePrefilledEmailResponseDTOFromJSON,
    CreatePrefilledEmailResponseDTOToJSON,
    ForbiddenResponseDTO,
    ForbiddenResponseDTOFromJSON,
    ForbiddenResponseDTOToJSON,
    NotFountResponseDTO,
    NotFountResponseDTOFromJSON,
    NotFountResponseDTOToJSON,
    PrefilledEmailResponseDTO,
    PrefilledEmailResponseDTOFromJSON,
    PrefilledEmailResponseDTOToJSON,
    UnauthorizedResponseDTO,
    UnauthorizedResponseDTOFromJSON,
    UnauthorizedResponseDTOToJSON,
    UpdatePrefilledEmailRequestDTO,
    UpdatePrefilledEmailRequestDTOFromJSON,
    UpdatePrefilledEmailRequestDTOToJSON,
} from '../models';

export interface PrefilledEmailsControllerCreatePrefilledEmailRequest {
    createPrefilledEmailRequestDTO: CreatePrefilledEmailRequestDTO;
}

export interface PrefilledEmailsControllerDeletePrefilledEmailRequest {
    emailId: number;
}

export interface PrefilledEmailsControllerUpdatePrefilledEmailsRequest {
    emailId: number;
    updatePrefilledEmailRequestDTO: UpdatePrefilledEmailRequestDTO;
}

/**
 * 
 */
export class EmailTemplatesApi extends runtime.BaseAPI {

    /**
     */
    async prefilledEmailsControllerCreatePrefilledEmailRaw(requestParameters: PrefilledEmailsControllerCreatePrefilledEmailRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<CreatePrefilledEmailResponseDTO>> {
        if (requestParameters.createPrefilledEmailRequestDTO === null || requestParameters.createPrefilledEmailRequestDTO === undefined) {
            throw new runtime.RequiredError('createPrefilledEmailRequestDTO','Required parameter requestParameters.createPrefilledEmailRequestDTO was null or undefined when calling prefilledEmailsControllerCreatePrefilledEmail.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/admin/email-templates`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePrefilledEmailRequestDTOToJSON(requestParameters.createPrefilledEmailRequestDTO),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreatePrefilledEmailResponseDTOFromJSON(jsonValue));
    }

    /**
     */
    async prefilledEmailsControllerCreatePrefilledEmail(requestParameters: PrefilledEmailsControllerCreatePrefilledEmailRequest, initOverrides?: RequestInit): Promise<CreatePrefilledEmailResponseDTO> {
        const response = await this.prefilledEmailsControllerCreatePrefilledEmailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async prefilledEmailsControllerDeletePrefilledEmailRaw(requestParameters: PrefilledEmailsControllerDeletePrefilledEmailRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.emailId === null || requestParameters.emailId === undefined) {
            throw new runtime.RequiredError('emailId','Required parameter requestParameters.emailId was null or undefined when calling prefilledEmailsControllerDeletePrefilledEmail.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/admin/email-templates/{emailId}`.replace(`{${"emailId"}}`, encodeURIComponent(String(requestParameters.emailId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async prefilledEmailsControllerDeletePrefilledEmail(requestParameters: PrefilledEmailsControllerDeletePrefilledEmailRequest, initOverrides?: RequestInit): Promise<void> {
        await this.prefilledEmailsControllerDeletePrefilledEmailRaw(requestParameters, initOverrides);
    }

    /**
     */
    async prefilledEmailsControllerGetPrefilledEmailsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<PrefilledEmailResponseDTO>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/admin/email-templates`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PrefilledEmailResponseDTOFromJSON));
    }

    /**
     */
    async prefilledEmailsControllerGetPrefilledEmails(initOverrides?: RequestInit): Promise<Array<PrefilledEmailResponseDTO>> {
        const response = await this.prefilledEmailsControllerGetPrefilledEmailsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async prefilledEmailsControllerUpdatePrefilledEmailsRaw(requestParameters: PrefilledEmailsControllerUpdatePrefilledEmailsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.emailId === null || requestParameters.emailId === undefined) {
            throw new runtime.RequiredError('emailId','Required parameter requestParameters.emailId was null or undefined when calling prefilledEmailsControllerUpdatePrefilledEmails.');
        }

        if (requestParameters.updatePrefilledEmailRequestDTO === null || requestParameters.updatePrefilledEmailRequestDTO === undefined) {
            throw new runtime.RequiredError('updatePrefilledEmailRequestDTO','Required parameter requestParameters.updatePrefilledEmailRequestDTO was null or undefined when calling prefilledEmailsControllerUpdatePrefilledEmails.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/admin/email-templates/{emailId}`.replace(`{${"emailId"}}`, encodeURIComponent(String(requestParameters.emailId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePrefilledEmailRequestDTOToJSON(requestParameters.updatePrefilledEmailRequestDTO),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async prefilledEmailsControllerUpdatePrefilledEmails(requestParameters: PrefilledEmailsControllerUpdatePrefilledEmailsRequest, initOverrides?: RequestInit): Promise<void> {
        await this.prefilledEmailsControllerUpdatePrefilledEmailsRaw(requestParameters, initOverrides);
    }

}
